import * as yup from 'yup';
import 'yup-phone';

export const addAttachmentValidationSchema = yup.object({
	requestAttachments: yup.array().min(1),
	notes: yup.string().required(),
});
